import { defineMessages } from "react-intl";

export const giftCardUpdateDetailsCardMessages = defineMessages({
  title: {
    id: "Zj/7QZ",
    defaultMessage: "Details",
    description: "details title",
  },
  setBalanceButtonLabel: {
    id: "PJDcQs",
    defaultMessage: "Set Balance",
    description: "set balance button label",
  },
  cardBalanceLabel: {
    id: "Z/7hyu",
    defaultMessage: "Card Balance",
    description: "card balance label",
  },
  tagInputLabel: {
    id: "a+kgkq",
    defaultMessage: "Card Tag",
    description: "tag label",
  },
});
